import { Role } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { isIbcCallCenterUser } from '@/hooks/layoutConstructor/iberiaUserHelpers';
import { useUser } from '@/hooks/useUser';

export const HomePageTitle = () => {
  const { userEntity } = useUser();
  const navigate = useNavigate();

  // FOR CREDIT CARD MERCHANTS / CHANNELS / AGENTS, WE REDIRECT TO THE CREDIT CARD LIST PAGE
  const isCreditCardUser = userEntity?.isCreditCardUser();
  const isTelemarketingAgent = userEntity?.hasRole([Role.ROLE_IBC_TLMK_AGENT]);

  const getCreditCardUserRedirectPath = () => {
    if (isTelemarketingAgent) return DYNAMIC_PAGE_PATHS.ACCOUNT;
    if (userEntity && isIbcCallCenterUser(userEntity)) return DYNAMIC_PAGE_PATHS.CREDIT_CARD_LIST;
    return DYNAMIC_PAGE_PATHS.CHECKOUT_SESSION_LIST;
  };

  useEffect(() => {
    if (isCreditCardUser) {
      navigate(getCreditCardUserRedirectPath());
    }
  }, []);

  return null;
};
